import React, {useEffect, useRef, useState} from 'react';
import Coupon from './Coupon.jsx';
import CouponInput from './CouponInput.jsx';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts/components/messages';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';
import {Collapsible} from '@bonprix/design-system';

export default function CouponWrapper({
                                          texts,
                                          coupon,
                                          onAddCoupon,
                                          onDeleteCoupon,
                                          pending,
                                          couponError,
                                          onCouponInput,
                                          cvpCode,
                                          isLastCheckPage,
                                          page
                                      }) {
    useEffect(() => {
        MessageBroker.publish(Messages.DOM.CHANGED, document.querySelector('.cart__coupon__accordion'));
    });

    useEffect(() => {
        if (cvpCode) {
            couponCollapsibleRef.current?.scrollIntoView();
        }
    }, [cvpCode]);

    const [couponEdited, setCouponEdited] = useState(false);
    const [previousCouponValue, setPreviousCouponValue] = useState('');

    const couponCollapsibleRef = useRef(null);

    const submitCoupon = (coupon) => onAddCoupon(coupon);
    const deleteCoupon = () => {
        setPreviousCouponValue(coupon?.code);
        onDeleteCoupon();
    }

    const sendOpenCouponLandmark = () => {
        LandmarkAdapter.sendClickLandmark((isLastCheckPage ? 'lastcheck' : 'cart') + '_layer_code');
    };

    const renderCoupon = () => {
        if (coupon && coupon.valid) {
            return (
                <Coupon texts={texts}
                        coupon={coupon}
                        clickHandler={deleteCoupon}
                        page={page}
                        setCouponEdited={setCouponEdited} />
            );
        }
        return (
            <CouponInput
                texts={texts}
                submitHandler={submitCoupon}
                pending={pending}
                couponError={couponError}
                onCouponInput={onCouponInput}
                prefilledValue={cvpCode || coupon?.code || previousCouponValue}
                isLastCheckPage={isLastCheckPage}
                onDeleteCoupon={deleteCoupon}
            />
        );
    };

    return (
        <>
            <Collapsible
                title={texts.cot_coupon_heading}
                initiallyOpened={cvpCode || coupon || couponEdited}
                onOpen={sendOpenCouponLandmark}
                rootRef={couponCollapsibleRef}
            >
                {renderCoupon()}
            </Collapsible>
        </>
    );
}
